import React from 'react'

function Weight_loss() {
  return (
    <div className='bg-white'>
    <div className="container-fluid loss-header mb-5">
        <div className="d-flex flex-column align-items-center justify-content-center pt-0 pt-lg-5" style={{minHeight: "670px"}}>
            <h4 className="display-4 mb-3 mt-0 mt-lg-5 text-white text-uppercase font-weight-bold">Weight- loss Diet</h4>
            <div className="d-inline-flex">
                <p className="m-0 text-white"><a className="text-white" href="">Home</a></p>
                <p className="m-0 text-white px-2">/</p>
                <p className="m-0 text-white">Weight- loss Diet</p>
            </div>
        </div>
    </div>

    <div className="container pt-5">
        <div className="d-flex flex-column text-center mb-5">
            <h4 className="text-primary font-weight-bold">Weight- loss Diet</h4>
            <h4 className="display-4 font-weight-bold">Latest Diet For Fitness</h4>
        </div>
        <div className="row">
            <div className="col-lg-6 mb-5 blog-item">
                <img className="img-fluid mb-4" src="img/Diet-1.jpg" alt="Image"/>
                <div className="d-flex align-items-center mb-4">
                    <div className="d-flex flex-column align-items-center justify-content-center rounded-circle bg-primary text-white" style={{width: "80px" ,height: "80px"}}>
                        <small>01</small>
                        <strong className="text-uppercase m-0 text-white">Jan</strong>
                        <small>2023</small>
                    </div>
                    <div className="pl-3">
                        <h3 className="font-weight-bold">What is daily diet chart?</h3>
                        <div className="d-flex">
                            <small className="mr-2 text-muted"><i className="fa fa-user"></i> Gymlover</small>
                            <small className="mr-2 text-muted"><i className="fa fa-folder"></i> Fitness</small>
                            <small className="mr-2 text-muted"><i className="fa fa-comments"></i> 15 Comments</small>
                        </div>
                    </div>
                </div>
                <p>
                    Nutritionist Recommended Balanced Diet Chart for Men and Women
                    A balanced diet chart is a representation of a healthy diet chart that comprises of all the required nutrients. It includes all the food groups and ensures that we are getting everything that our body needs through our diet. It is a guideline that gives us the right food choices for optimal health</p>
            </div>
            <div className="col-lg-6 mb-5 blog-item">
                <img className="img-fluid mb-4" src="img/Diet-2.jpg" alt="Image"/>
                <div className="d-flex align-items-center mb-4">
                    <div className="d-flex flex-column align-items-center justify-content-center rounded-circle bg-primary text-white" style={{width: "80px" ,height: "80px"}}>
                        <small>01</small>
                        <strong className="text-uppercase m-0 text-white">Jan</strong>
                        <small>2023</small>
                    </div>
                    <div className="pl-3">
                        <h3 className="font-weight-bold">	Diet Chart</h3>
                        <div className="d-flex">
                            <small className="mr-2 text-muted"><i className="fa fa-user"></i> Gymlover</small>
                            <small className="mr-2 text-muted"><i className="fa fa-folder"></i> Normal </small>
                            <small className="mr-2 text-muted"><i className="fa fa-comments"></i> 151 Comments</small>
                        </div>
                    </div>
                </div>
                <p>
                    <ul>6:30 AM	Cucumber Detox Water (1 glass)</ul>
                    <ul>8:00 AM	Curd (1.5 katori) Mixed Vegetable Stuffed Roti (2 pieces)</ul>
                    <ul>12:00 PM	Skimmed Milk Paneer (100 grams)</ul>
                    <ul>2:00 PM	Mixed Vegetable Salad (1 katori)</ul>
                    <ul>2:10 PM	Lentil Curry (0.75 bowl) Methi Rice (0.5 katori)</ul>
                    <ul>4:00 PM	Apple (0.5 small (2-3/4″ dia)) Buttermilk (1 glass)</ul>
                    <ul>5:30 PM	Coffee with Milk and Less Sugar (0.5 tea cup)</ul>
                    <ul>8:50 PM	Mixed Vegetable Salad (1 katori)</ul>
                    <ul>9:00 PM	Sauteed Vegetables with Paneer (1 katori) Roti (1 roti/chapati)</ul>
                    Green Chutney (2 tablespoon)
                    
                    </p>
            </div>
            <div className="col-lg-6 mb-5 blog-item">
                <img className="img-fluid mb-4" src="img/Diet-3.jpg" alt="Image"/>
                <div className="d-flex align-items-center mb-4">
                    <div className="d-flex flex-column align-items-center justify-content-center rounded-circle bg-primary text-white" style={{width: "80px" ,height: "80px"}}>
                        <small>01</small>
                        <strong className="text-uppercase m-0 text-white">Jan</strong>
                        <small>2023</small>
                    </div>
                    <div className="pl-3">
                        <h3 className="font-weight-bold">Mediterranean Diet,</h3>
                        <div className="d-flex">
                            <small className="mr-2 text-muted"><i className="fa fa-user"></i> Gymlover</small>
                            <small className="mr-2 text-muted"><i className="fa fa-folder"></i> Fitness</small>
                            <small className="mr-2 text-muted"><i className="fa fa-comments"></i> 154 Comments</small>
                        </div>
                    </div>
                </div>
                <p> DASH Diet, and Flexitarian Diets Remain the Best Diets of 2023. All three diets are highly recommended by doctors because of their known health benefits. “The Mediterranean eating plan doesn't have a set calorie range or portion guidelines, which is why it can fit almost anyone's needs.</p>
                <li>Day 4 </li>
                <p> On the fourth day, start with a milkshake containing lots of nuts as well as your choice of fruits; you can also have a stuffed omelet with cheese, mushrooms, and onions  
                For lunch have a big bowl of urad dal, veggies, and paneer paratha  
                For dinner, you can have half a bowl of rice, and for protein include palak chole 
                For snacking continue eating fruits, yogurt, or buttermilk</p>
                <li>Day 5 </li>
                <p>Start your day with a glass of low-fat milk and veggie upma for breakfast 
                For lunch, you can have a stuffed roti alongside a paneer bhurji with veggies  
                For dinner have 1 roti, 1 bowl of dal or yogurt, and 1 sabzi like a beans curry or baingan bharta </p>
            </div>
            <div className="col-lg-6 mb-5 blog-item">
                <img className="img-fluid mb-4" src="img/Diet -4.jpg" alt="Image"/>
                <div className="d-flex align-items-center mb-4">
                    <div className="d-flex flex-column align-items-center justify-content-center rounded-circle bg-primary text-white" style={{width: "80px" ,height: "80px"}}>
                        <small>01</small>
                        <strong className="text-uppercase m-0 text-white">Jan</strong>
                        <small>2023</small>
                    </div>
                    <div className="pl-3">
                        <h3 className="font-weight-bold">5 days Diet</h3>
                        <div className="d-flex">
                            <small className="mr-2 text-muted"><i className="fa fa-user"></i> Gymlover</small>
                            <small className="mr-2 text-muted"><i className="fa fa-folder"></i> Fitness</small>
                            <small className="mr-2 text-muted"><i className="fa fa-comments"></i> 113 Comments</small>
                        </div>
                    </div>
                </div>
               <li>Day 1 </li> 
               <p> Start your day by drinking cucumber water 
                Then for breakfast have 1 bowl of oats porridge with skimmed milk 
                Have a bowl of dal, sabzi, and 1 roti or 1 cup of brown rice for lunch 
                For dinner fill your plate with a bowl of dal, sabzi, and 1 roti  
                To satisfy mid-meal hunger pangs try snacking on fruits, 1 glass of buttermilk, or one bowl of yogurt </p>
               <li> Day 2 </li>
                <p>Start your day with cucumber detox water or one glass of lukewarm water in the morning 
                To bring in some variety to your breakfast try consuming a mixed vegetable chilla along with curd (Avoid pickles initially, but you can add pickles to your meal once in a while at a later stage) 
                For lunch, have one bowl of palak pulao with dal  
                At night, skip the roti and instead increase your intake of vegetables 
                You can include paneer and sautéed vegetables in your dinner</p>
                <li>Day 3 </li>
                <p>On the third day, you can skip Indian food and include multigrain brown bread toast and a bowl of fruits in yogurt for your breakfast 
                For lunch, introduce sautéed vegetables along with paneer and have 1 small bowl of rice to compliment your carbohydrate requirement 
                For dinner, try some panner curry with a bowl of vegetables (You can consume any type of vegetable as per your palate and cravings) 
                For snacking, depend on fruits and yogurt or buttermilk </p>
              
            </div>
        </div>
    </div>
    </div>
  )
}

export default Weight_loss